(() => {
  if (window.__collectionFeatureDetailBadgeInitialized) {
    return;
  }
  window.__collectionFeatureDetailBadgeInitialized = true;

  const PRODUCT_SELECTOR = '.collection-feature-card__product';
  const BADGE_SELECTOR = '.collection-feature-card__detail-badge';
  const activePointerTypes = new WeakMap();

  /**
   * @param {EventTarget | null} target
   * @returns {HTMLElement | null}
   */
  const getProductElement = (target) => {
    if (!(target instanceof Element)) return null;
    const product = target.closest(PRODUCT_SELECTOR);

    if (!(product instanceof HTMLElement)) {
      return null;
    }

    return product;
  };

  /**
   * @param {HTMLElement} product
   * @returns {HTMLElement | null}
   */
  const getBadge = (product) => {
    const badge = product.querySelector(BADGE_SELECTOR);
    return badge instanceof HTMLElement ? badge : null;
  };

  /**
   * @param {HTMLElement} product
   * @param {PointerEvent} event
   */
  const showBadge = (product, event) => {
    const badge = getBadge(product);
    if (!badge) return;

    if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') {
      hideBadge(product);
      return;
    }

    activePointerTypes.set(product, event.pointerType);
    product.classList.add('is-detail-badge-active');
    badge.classList.add('is-visible');
    updateBadgePosition(product, badge, event);
  };

  /**
   * @param {HTMLElement} product
   */
  const hideBadge = (product) => {
    const badge = getBadge(product);
    if (!badge) return;

    activePointerTypes.delete(product);
    product.classList.remove('is-detail-badge-active');
    badge.classList.remove('is-visible');
    badge.style.removeProperty('left');
    badge.style.removeProperty('top');
  };

  /**
   * @param {HTMLElement} product
   * @param {HTMLElement} badge
   * @param {PointerEvent} event
   */
  const updateBadgePosition = (product, badge, event) => {
    const rect = product.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    badge.style.left = `${x}px`;
    badge.style.top = `${y}px`;
  };

  /** @param {PointerEvent} event */
  const handlePointerEnter = (event) => {
    const product = getProductElement(event.target);
    if (!product || !getBadge(product)) return;

    showBadge(product, event);
  };

  /** @param {PointerEvent} event */
  const handlePointerMove = (event) => {
    const product = getProductElement(event.target);
    if (!product) return;

    const activePointerType = activePointerTypes.get(product);
    if (!activePointerType || activePointerType !== event.pointerType) {
      return;
    }

    const badge = getBadge(product);
    if (!badge) {
      hideBadge(product);
      return;
    }

    updateBadgePosition(product, badge, event);
  };

  /** @param {PointerEvent} event */
  const handlePointerLeave = (event) => {
    const product = getProductElement(event.target);
    if (!product) return;

    if (!activePointerTypes.has(product)) {
      return;
    }

    hideBadge(product);
  };

  document.addEventListener('pointerenter', handlePointerEnter, true);
  document.addEventListener('pointermove', handlePointerMove, true);
  document.addEventListener('pointerleave', handlePointerLeave, true);
  document.addEventListener('pointercancel', handlePointerLeave, true);
})();
